import { type FC } from "react";

import { Popover, PopoverPlacementTypes } from "@snapchat/snap-design-system";
import { FilterFilledIcon } from "@snapchat/snap-design-system-icons";

import { type SpecApprovalState } from "../../../../gql-generated/types";
import { ClickableHeaderItem, filterIcon } from "../../../../lenses/components/list/header";
import { Flexbox } from "../../../../shared/components";
import { popoverStyle } from "../../../../shared/styles";
import { StatusLabel } from "../../messages.generated";

import { ApiFilterOptions } from "./ApiFilterOptions";
import { baseWidth } from "./HeaderWidth.style";
import { type StatusFilter } from "./models";

interface ApiStatusHeader {
    onStatusFilter: StatusFilter;
    statusFilters: Set<SpecApprovalState>;
}

export const ApiStatusHeader: FC<ApiStatusHeader> = ({ onStatusFilter, statusFilters }) => {
    return (
        <Popover
            trigger="click"
            placement={PopoverPlacementTypes.BOTTOM_LEFT}
            className={popoverStyle}
            content={<ApiFilterOptions statusFilters={statusFilters} onStatusFilter={onStatusFilter} />}
        >
            <ClickableHeaderItem className={baseWidth}>
                <Flexbox flexDirection="row" alignItems="center">
                    <span>
                        <StatusLabel />
                    </span>
                    <FilterFilledIcon className={filterIcon} />
                </Flexbox>
            </ClickableHeaderItem>
        </Popover>
    );
};
